import classnames from "classnames";

import style from "./style.module.scss";
import type { SliderProps } from "../../types";

function Slider({ value, onChange, min = 0, max = 100, step = 1, className }: SliderProps) {
  return (
    <input
      type="range"
      min={min}
      max={max}
      step={step}
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
      className={classnames(style.slider, className)}
    />
  );
}

export default Slider;
